// extracted by mini-css-extract-plugin
export var preview = "CategoryPreview-module--preview--dKz0r";
export var title = "CategoryPreview-module--title--vLDqu";